<template>
    <el-table class="table-box" ref="elTable"
        @header-dragend="headerDragendHandler"
        @selection-change="handleSelectionChange"
        header-cell-class-name="table-box-header-cell"
        :data="newRows" border style="width: 100%" tooltip-effect="dark" :row-class-name="rowClassHandler"
        v-bind="attrsExt" v-on="$listeners">
        <el-table-column v-if="selection" type="selection" :reserve-selection="reserveSelection" fixed="left" width="40" align="center" :selectable="selectable"></el-table-column>
        <el-table-column v-if="index" type="index" :index="1" width="40"></el-table-column>
        <template v-for="(col, cIndex) in activeColumns">
            <el-table-column
            :key="col.prop + cIndex"
            :min-width="col.width"
            :width="!col.columnStick ? col.width : ''"
            :label="col.label"
            :fixed="col.fixed"
            :show-overflow-tooltip="_.get(col, 'showTooltip', true)">
                <template v-slot:header>
                    <slot name="col-header" v-bind="{ col }">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="col.label"
                            placement="top">
                                <span :title="col.label">{{col.label}}</span>
                        </el-tooltip>
                    </slot>
                    <table-for-search
                        v-if="col.searchField"
                        :searchField="_.get(col, 'searchField',{})"
                        @fieldChange="searchFieldChange"
                        @doSearch="doSearch"
                        v-model="searchData[_.get(_.get(col, 'searchField',{}), 'value',null)]"
                    ></table-for-search>
                    <div v-if="col.searchField">
                        <slot name="col-search-header" v-bind="{
                            searchField:_.get(col, 'searchField',{}) ,
                            searchData:searchData ,
                            fieldName:_.get(_.get(col, 'searchField',{}),'value',null) ,
                            fieldChange:searchFieldChange, doSearch:doSearch
                        }">
                        </slot>
                    </div>
                </template>
                <template slot-scope="scope">
                    <template v-if="!col.type">{{scope.row[col.prop]}}</template>
                    <template v-else-if="col.type === 'select'">{{scope.row[col.prop] | keyMapFormat(col.options)}}</template>
                    <slot v-else name="col-append" v-bind="{ col, row: scope.row, rIndex: scope.$index }"></slot>
                </template>
                <slot name="nest-table" v-bind="{col}"></slot>
            </el-table-column>
        </template>
        <el-table-column :label="$translate('component.E202006152352', { defaultText: '操作' })" fixed="right" :width="actionColWidth" v-if="actionColShow">
            <template slot-scope="scope">
                <template v-for="(e, eIndex) in actions.list">
                    <el-button v-if="e.displayRule(scope.row)" type="text" size="mini" :key="eIndex" @click="actionClick(e.event, scope.row, scope.$index)">{{e.label}}</el-button>
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import _ from 'lodash';
import { dictWithUrl } from '../api';
import { I18nMixins } from '@/components/utils/i18n';
import { setLocal, getLocal } from '@/components/utils/storage';
import tableForSearch from './tableForSearch';
export default {
    name: 'tableBox',
    mixins: [I18nMixins],
    inheritAttrs: false,
    components: { tableForSearch },
    props: {
        height: {
            type: [Number, String],
            default() {
                const heightOffset = 152;
                const $el = document.querySelector('.app-main');
                if (!$el) return 0;
                const tableHeight = $el.getBoundingClientRect().height - heightOffset;
                return tableHeight;
            }
        },
        actions: {
            type: Object,
            default() {
                return {
                    list: []
                };
            },
            validator: function (obj) {
                return !!obj.list;
            }
        },
        columns: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        rows: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        selection: {
            type: Boolean,
            default() {
                return false;
            }
        },
        selectable: {
            type: Function,
            default() {
                return true;
            }
        },
        index: {
            type: Boolean,
            default() {
                return false;
            }
        },
        reserveSelection: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    watch: {
        actions: {
            handler(val) {
                if (val.list) {
                    _.forEach(val.list, ele => {
                        if (!_.isFunction(ele.displayRule)) {
                            ele.displayRule = () => true;
                        }
                    });
                }
            },
            immediate: true
        },
        rows: {
            handler(val) {
                // fix 修正elementui多个tab都包含表格，切换tab时table复选框绝对定位计算错误的问题
                this.$refs.elTable.debouncedUpdateLayout();
                this.newRows = val;
            },
            immediate: false
        },
        activeColumns: {
            handler() {
                // 对newRows进行延迟赋值是为了修正列变化时右fix的操作列top属性计算异常的问题
                if (this.rows.length > 0) {
                    this.newRows = [];
                }
                this.$nextTick(() => {
                    this.newRows = this.rows;
                    this.$refs.elTable.debouncedUpdateLayout();
                });
            },
            immediate: false
        }
    },
    computed: {
        _() {
            return _;
        },
        attrsExt() {
            const result = _.cloneDeep(this.$attrs);
            if (!_.has(result, 'max-height') && !_.has(result, 'height')) {
                result.height = this.height;
            }
            return result;
        },
        actionColShow() {
            return this.actions.list && this.actions.list.length > 0;
        },
        actionColWidth() {
            const btnWidth = 50;
            return this.actions.fixedWidth || btnWidth * this.actions.list.length;
        },
        activeColumns() {
            return this.columns.filter(item => !item.hiddenColumn);
        }
    },
    filters: {
        keyMapFormat(val, options) {
            if (!options) return val;
            // 方案1的处理方式：options保持elementui格式
            // const obj = _.find(options, ['value', val]);
            // return _.get(obj, 'label', val);

            // 方案2的处理方式：options使用简单对象
            return _.get(options, val, val);
        }
    },
    data() {
        return {
            newRows: [],
            columnsWidthConfig: null,
            searchData: {},
            selectedRowsData: []
        };
    },
    methods: {
        actionClick(event, row, rIndex) {
            this.$emit('action-click', event, row, rIndex);
        },
        getTable() {
            return this.$refs['elTable'];
        },
        rowClassHandler({ row }) {
            return this.getTable().selection.includes(row) ? 'selected-row' : '';
        },
        searchFieldChange(data) {
            this.searchData[data.fieldName] = data.value;
            this.$emit('search-field-change', data.fieldName, data.value);
        },
        doSearch() {
            this.$emit('do-search', this.searchData);
        },
        // 重新配置列宽度
        resetColumnWidth(columnsList) {
            this.columnsWidthConfig && Object.keys(this.columnsWidthConfig).forEach(key => {
                const col = columnsList.find(e => e.prop === key);
                if (col) {
                    col.width = this.columnsWidthConfig[key];
                }
            });
            return columnsList;
        },
        headerDragendHandler(newWidth, oldWidth, column) {
            this.columnsWidthConfig = this.columnsWidthConfig || {};
            this.columnsWidthConfig[column.property] = newWidth;
            setLocal(this.columnWidthCacheIdentifer, this.columnsWidthConfig);
        },
        // 当选择项发生变化时触发事件
        handleSelectionChange(selection) {
            this.selectedRowsData = selection;
            this.$emit('onSelectionChange', selection);
        },
        setTableBoxQueryParams(initialVal) { // 设置表格搜索默认值
            this.searchData = Object.assign({}, _.cloneDeep(initialVal));
        }
    },
    created() {
        this.columns.forEach(item => {
            if (item.optionsKey) {
                dictWithUrl(item.optionsKey, item.dictUrl).then(res => {
                    this.$set(item, 'options', res.data[item.optionsKey] || {});
                });
            }
            return item;
        });
        this.columnsWidthConfig = getLocal(this.columnWidthCacheIdentifer);
        this.resetColumnWidth(this.activeColumns);
    }
};

</script>
<style lang="less">
.table-box {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 100%;
    }
    .el-table__header{
        thead{
            .cell{
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
        }
    }
    .table-box-header-cell {
        .cell {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }
        .caret-wrapper {
            order: 2;
        }
        .table-search {
            order: 3;
            padding: 0;
            .el-select,.el-input {
                padding: 0;
            }
        }
    }
}
</style>
